(function ($, Drupal) {

  "use strict";

  Drupal.behaviors.fund = {
    attach: function (context, settings) {
      const $tables = $('.node--fund .performance-table');
      
      if ($tables.length) {
        $tables.each(function () {
          if ($(this).find('thead:contains("Annualized")').length) {
            $(this)
              .before('<div class="performance-table__heading"><small>Average Annualized Return</small><span>Since inception</span></div>');
          }
        });
      }
    }
  };

})(jQuery, Drupal);
